import { observer } from "mobx-react";
import React from "react";
import { Modal } from "@mantine/core";
import PaidNotificationDesign from "./helpers/PaidSuccessfulNotificationDesign";
import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import { BOB_MODALS } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import PaidFailureNotificationDesign from "./helpers/PaidFailureNotificationDesign";

const PayAttemptFailed = observer(({ bob }: { bob: Bob }) => {
  const selectedPayAttempt = bob.selectedPayAttempt;

  const handleClose = () => {
    bob.setOpenModal(null);
    bob.selectPayAttempt(undefined);
  };

  if (!selectedPayAttempt || !selectedPayAttempt.payAmountSatoshis) return null;

  const fiat = selectedPayAttempt.bob.formatFiat(
    selectedPayAttempt.payAmountSatoshis
  );

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.PAY_ATTEMPT_FAILED}
      onClose={handleClose}
      size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      radius="md"
      withCloseButton={false}
      overlayProps={{ blur: 0.8 }}
    >
      <PaidFailureNotificationDesign
        title="Payment failed"
        satoshis={selectedPayAttempt.payAmountSatoshis}
        fiat={fiat}
        onClick={handleClose}
      />
    </Modal>
  );
});

export default PayAttemptFailed;
